import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { FC, useMemo } from 'react'

import { MeasureController } from 'core/analytics'
import { IPartnerContact } from 'partner360/features/contacts'

import { PartnerContactRoles } from '../../partnerContactRoles/PartnerContactRoles'
import { FormContactRoles } from '../contactRolesSelector/ContactRolesSelector'

import styles from './ContactDetails.module.scss'

interface IContactDetailsProps {
  contact: IPartnerContact
  isContactEditing?: boolean
  programType: ProgramTypes
  metrics: MeasureController
  onContactChange: (contact: IPartnerContact) => void
}

export const ContactDetails: FC<IContactDetailsProps> = ({
  contact,
  isContactEditing = false,
  programType,
  metrics,
  onContactChange,
}) => {
  const fullName = useMemo(() => {
    return [contact.FirstName, contact.LastName].filter((it) => it).join(' ') || '-'
  }, [contact])

  const email = contact.Email || '-'

  return (
    <div className={styles.root}>
      <div className={styles.fullName}>{fullName}</div>
      <div className={styles.email}>{email}</div>
      <div className={styles.roles}>
        {isContactEditing ? (
          <FormContactRoles
            programType={programType}
            metrics={metrics}
            contact={contact}
            onChange={onContactChange}
          />
        ) : (
          <PartnerContactRoles role={contact.Roles} />
        )}
      </div>
    </div>
  )
}
